<hr/>
<p class="text-center pitch-start-btn" *ngIf="!gatePass.is_logged_in">
<a [routerLink]="['/user/new/step/one']" class="btn btn-outline-primary btn-lg">Free Signup & 1 Month Trial</a>
<app-get-it-from-google-play></app-get-it-from-google-play>
</p>
<hr/>
